import React, { useEffect } from 'react';
import styles from './swp.module.css';
import { Swiper } from 'antd-mobile';
import { BoutiqueItem } from './interface';
import { Link } from 'react-router-dom';
import statisticsApi from '../../../lib/statisticsApi';

export default ({ bdArr, strSwpArr, tip }: { bdArr: BoutiqueItem[]; strSwpArr: string[]; tip: string }) => {
  const arr = ['selection', 'publish', 'original'];

  function ck() {
    if (tip === arr[0]) {
      statisticsApi.statisticsApi(20);
    }
    if (tip === arr[1]) {
      statisticsApi.statisticsApi(40);
    }
    if (tip === arr[2]) {
      statisticsApi.statisticsApi(80);
    }
  }

  function linkText(i: number, id: string) {
    if (strSwpArr[i] === 'subjectDetails') {
      return `/subjectDetails?id=${id}`;
    }
    if (strSwpArr[i] === 'bookListDetails') {
      return `/bookListDetails?id=${id}`;
    }
    return '';
  }

  return (
    <>
      <Swiper trackOffset={25} slideSize={50} stuckAtBoundary={false} loop={true} autoplay={true} autoplayInterval={5000} indicator={() => null}>
        {bdArr.map((item, index) => {
          return (
            <Swiper.Item key={index}>
              <Link
                to={linkText(index, item.shudan?.shudan_id || item.subject?.subject_id)}
                onClick={() => {
                  ck();
                }}
              >
                <img src={item.shudan?.cover_url || item.subject?.cover_url} className={styles.swiperItem}></img>
              </Link>
            </Swiper.Item>
          );
        })}
      </Swiper>
    </>
  );
};
